import { useRouter } from 'next/navigation'
import axios from 'axios'
import { useMemo } from 'react'

const isTokenMode = process.env.NEXT_PUBLIC_AUTH_MODE === 'token'

const useAxiosInstance = () => {
    const router = useRouter()

    const axiosInstance = useMemo(() => {
        // Axios Instance
        const instance = axios.create({
            baseURL: process.env.NEXT_PUBLIC_BACKEND_URL,
            withCredentials: true,
            withXSRFToken: !isTokenMode, // XSRF token only needed for cookie-based auth
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
            },
        })

        // In token mode, attach the Bearer token from localStorage on every request
        if (isTokenMode) {
            instance.interceptors.request.use(config => {
                const token =
                    typeof window !== 'undefined'
                        ? localStorage.getItem('auth_token')
                        : null
                if (token) {
                    config.headers['Authorization'] = `Bearer ${token}`
                }
                return config
            })
        }

        return instance
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return axiosInstance
}

export default useAxiosInstance
